<iframe [src]="URl" style="height: calc(100vh - 60px);width: 100%;" loading="lazy" frameborder="0"></iframe>
<mat-dialog-actions class="popup-footer">
  <button *ngIf="isFromLogin" mat-raised-button color="primary" (click)="saveClick()">
    <i class="fas fa-check"></i> Accept
  </button>
  <button mat-raised-button color="warn" (click)="cancelClick()">
    <i class="fas fa-times"></i> {{isFromLogin ? 'Reject' : 'Close'}}
  </button>
</mat-dialog-actions>